import styled from "styled-components";
import { Radio, Select, Modal, Table, Button, Upload } from "antd";
import { COLORS, WEIGHT } from "../../../../layout/theme";

export const Inner = styled.div`
	& .noBackground,
	& .noBackground:hover {
		background-color: ${COLORS.White} !important;
		border: none;
	}
`;

export const Filters = styled.div`
	margin: 20px 0;

	& button {
		padding: 0 !important;
	}
`;

export const AntdSelect = styled(Select)`
	border: none;
	font-weight: ${WEIGHT.SemiBold};
	min-width: 150px;
`;

export const AntdOption = styled.div`
	border: none;
	font-weight: ${WEIGHT.SemiBold};
	color: ${COLORS.Grey};
`;

export const PreviewImage = styled.img`
	width: 150px;
	height: 150px;
	object-fit: contain;
`;

export const ActionButton = styled.button`
	border: none;
	border-radius: 5px;
	background-color: transparent;
	padding: 5px;
	cursor: pointer;
	color: ${COLORS.Primary};

	&:hover {
		background-color: ${COLORS.Grey};
	}
`;

export const AntdModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 10px;
	}

	.ant-modal-header {
		border-radius: 10px 10px 0 0;
	}
	.ant-modal-body {
		background-color: ${COLORS.LightGrey};
		padding: 1rem 5rem 1rem 5rem;
		border-radius: 0 0 10px 10px;
	}
	.ant-modal-footer {
		text-align: left;
		height: 80px;
	}
`;
export const AntdTable = styled(Table)`
	& .hasChanges,
	& .hasChanges:hover {
		color: ${COLORS.Default} !important;
		background-color: ${COLORS.LightDefault} !important;
	}

	.ant-table-thead > tr > th {
		background: ${(props) =>
			props.background ? props.background : COLORS.Primary};
	}

	.ant-table-row {
		background: ${(props) =>
			props.rowBackground ? props.rowBackground : COLORS.White};
	}

	.ant-table-thead
		> tr
		> th:not(:last-child):not(.ant-table-selection-column):not(
			.ant-table-row-expand-icon-cell
		):not([colspan])::before {
		background-color: ${(props) =>
			props.background ? props.background : COLORS.Primary};

		div {
			color: ${(props) =>
				props.background ? props.background : COLORS.Primary};
		}
	}

	.ant-table-container table > thead > tr:first-child th:first-child {
		border-radius: 20px 0 0 0;
	}

	.ant-table-container table > thead > tr:first-child th:last-child {
		border-radius: 0 20px 0 0;
	}

	/* Inputs dentro de la tabla */
	.ant-input,
	.ant-input-affix-wrapper,
	.ant-input-number,
	.ant-select-selector {
		border-radius: 12px !important;
		border: 1px solid #d1d5db !important;
		box-shadow: none !important;
		min-height: 35px;
	}

	.ant-input {
		padding: 0 12px;
	}

	.ant-input:hover,
	.ant-input-affix-wrapper:hover,
	.ant-input-number:hover,
	.ant-select-selector:hover {
		border-color: ${COLORS.DarkGrey} !important;
	}

	.ant-input:focus,
	.ant-input-focused,
	.ant-input-affix-wrapper-focused,
	.ant-input-number-focused,
	.ant-select-focused .ant-select-selector {
		border-color: ${COLORS.DarkGrey} !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	/* Para los Input con addonAfter (% / un.) */
	.ant-input-group-wrapper {
		border-radius: 12px !important;
	}

	.ant-input-group {
		border-radius: 12px !important;
	}

	.ant-input-group .ant-input {
		border-radius: 12px 0 0 12px !important;
	}

	.ant-input-group-addon {
		border-radius: 0 12px 12px 0 !important;
		border: 1px solid #d1d5db !important;
		border-left: 0 !important;
		background: #f8fafc !important;
		color: #64748b !important;
		font-weight: 600;
		padding: 0 10px;
	}

	/* Para que el focus se vea correcto también en grupos */
	.ant-input-group-wrapper:hover .ant-input,
	.ant-input-group-wrapper:hover .ant-input-group-addon {
		border-color: ${COLORS.DarkGrey} !important;
	}

	.ant-input-group-wrapper .ant-input:focus + .ant-input-group-addon,
	.ant-input-group-wrapper .ant-input-focused + .ant-input-group-addon {
		border-color: ${COLORS.DarkGrey} !important;
	}
`;

export const TableContainer = styled.div`
	margin-top: 10px;

	.ant-table table {
		background-color: ${(props) =>
			props.containerBackground
				? props.containerBackground
				: COLORS.LightGrey} !important;
	}
`;

export const ConfirmButton = styled.div`
	${(props) =>
		!props.clientId
			? `
	display: flex;
	justify-content: end;
  gap: 20px;`
			: `display: flex;
	justify-content: start;
  gap: 20px;`}
`;
export const AntdButton = styled(Button)`
	width: 200px;
	height: 40px;
	background-color: ${(props) =>
		props.success ? COLORS.Success : COLORS.Default};
	color: ${COLORS.White};
	border: 1px solid
		${(props) => (props.success ? COLORS.Success : COLORS.Default)};
	border-radius: 7px;
	padding: 0.5rem 0;
	&:hover {
		background-color: ${(props) =>
			props.success ? COLORS.Success : COLORS.Default};
	}
	& span {
		color: ${COLORS.White};
	}
`;

export const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 20px;
`;

export const CompaginationDiv = styled.div`
	display: flex;
	gap: 4px;
`;
export const SpinnerContainer = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	align-content: center;
	justify-content: center;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	gap: 20px;
`;

export const ContainerTitle = styled.div`
	display: flex;
	align-items: start;
	gap: 5px;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const Buttons = styled.div`
	${(props) =>
		!props.clientId
			? `
      display: flex;
      width: 100%;
      justify-content: end;
      position: absolute;
      transform: translateY(-86px);
      & button {
        padding: 0 !important;
      }

      @media only screen and (min-width: 760px) and (max-width: 1200px) {
        flex-direction: column;
        height: 150px;
      }
  `
			: `
    display: flex;
    width: 100%;
    justify-content: start;
    & button {
      padding: 0 !important;
    }
  `}
`;

export const ButtonsLeft = styled.div`
	display: flex;
	gap: 20px;
	align-items: baseline;
	margin: 20px 0;
`;
export const SpanCointainer = styled.div`
	${(props) => (!props.clientId ? `margin: 60px 0;` : `margin: 10px`)}
`;
export const Span = styled.span`
	cursor: pointer;
	color: ${COLORS.Secondary};
	margin-right: 60px;
	font-weight: ${WEIGHT.ExtraBold};
`;

export const UploadFile = styled(Upload)`
	width: 150px;
	height: 40px;
	font-size: 16px;
	font-weight: 700;
	display: flex;
	justify-content: center;
	background-color: ${COLORS.Secondary};
	color: ${COLORS.White};
	align-items: center;
	border: 1px solid ${COLORS.Secondary};
	border-radius: 15px;
	padding: 0.5rem 0;
	cursor: pointer;
	&:hover {
		background-color: ${COLORS.Secondary};
	}
	& span {
		color: ${COLORS.White};
	}
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: center;

	.ant-picker,
	.ant-select-selector {
		height: 40px !important;
		border-radius: 14px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: none !important;
		font-size: 16px !important;
	}

	.ant-picker {
		padding: 0 16px !important;
	}

	.ant-select-selector {
		padding: 0 16px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select-selection-placeholder,
	.ant-select-selection-item {
		color: #334155 !important;
		font-size: 16px !important;
	}

	.ant-picker:hover,
	.ant-picker-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select:hover .ant-select-selector {
		border-color: ${COLORS.DarkGrey} !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	.ant-picker-range {
		min-width: 260px;
	}

	@media only screen and (max-width: 1200px) {
		.ant-picker-range,
		.ant-select {
			flex: 1 1 220px;
			min-width: 220px;
		}
	}

	@media only screen and (max-width: 768px) {
		.ant-picker-range,
		.ant-select,
		.ant-input-affix-wrapper {
			width: 100%;
			min-width: 100%;
		}
	}
`;

export const FilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FilterActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	margin-left: auto;

	@media only screen and (max-width: 1200px) {
		margin-left: 0;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;

export const Section = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

export const TableWrapper = styled.div`
	width: 100%;
	border-radius: 20px;
	overflow: hidden;
`;

export const RadioOptions = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 20px;
	margin-bottom: 20px;

	.ant-radio-group {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}

	.ant-btn {
		border-radius: 10px !important;
	}
`;

export const AntdRadioButton = styled(Radio.Button)`
	border: 1px solid #e5e7eb !important;
	border-radius: 10px !important;
	font-weight: ${WEIGHT.Bold};
	background: #ffffff !important;
	color: #6b7280 !important;
	box-shadow: none !important;

	&.ant-radio-button-wrapper-checked {
		background: #eef2ff !important;
		border-color: #c7d2fe !important;
		color: #3730a3 !important;
	}

	&:before {
		display: none !important;
	}
`;
